<template>
  <div class="home-sns-team-select-page">
    <header-pane
      class="home-page__header"
      colorType="light"
      :pageTitle="$tc('HomePage.pageTitle')"
    />

    <sub-header-section :pageTitle="$tc('HomeSnsTeamSelectPage.pageTitle')" backLink="/home" />

    <home-sns-team-select-pane class="home-sns-team-select-page__content" @changed="moveToHome" />

    <global-navigation-pane current="home" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import HomeSnsTeamSelectPane from '@/components/HomeSnsTeamSelectPage/HomeSnsTeamSelectPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'

export type DataType = {
  screenTransitionModal: boolean
  screenTransitionTo: string
}

/**
 * HOME: SNS投稿表示チーム選択ページ
 */
export default defineComponent({
  name: 'HomeSnsTeamSelectPage',
  components: {
    HeaderPane,
    SubHeaderSection,
    HomeSnsTeamSelectPane,
    GlobalNavigationPane,
  },
  data(): DataType {
    return {
      screenTransitionModal: false, // 画面遷移警告モーダル表示フラグ
      screenTransitionTo: '', // 画面遷移警告モーダル 遷移先指定
    }
  },
  methods: {
    /**
     * HONE画面に遷移する
     */
    moveToHome(): void {
      this.$router.replace({ name: 'HomePage' })
    },
  },
})
</script>
<style lang="scss" scoped>
.home-sns-team-select-page {
  background: $gray1;
  min-height: var(--screen-height);
  padding-bottom: var(--safe-area-inset-bottom);
}
</style>
